<div class="override-toggle">
    <cerrix-checkbox
        data-uiid="use-parent-or-default-matrix"
        [label]="'useParentOrDefaultMatrixLabel' | t"
        [(value)]="row.UseParentOrDefaultMatrix"
    ></cerrix-checkbox>
</div>
<hr />
@if (row.UseParentOrDefaultMatrix) {
    <div class="parent-matrix-viewer">
        @if (row.ParentMatrix) {
            <label>
                {{ "parentMatrixPreviewLabel" | t }}
            </label>
            <cerrix-riskmatrix-summary
                [matrix]="row.ParentMatrix"
                [cellSize]="cellSize"
                [cellSpacing]="cellSpacing"
            ></cerrix-riskmatrix-summary>
        } @else {
            <label>
                {{ "noParentMatrixPreviewLabel" | t }}
            </label>
        }
    </div>
} @else {
    @if (value) {
        <div class="risk-matrix-editor">
            @if (summaryListConfig) {
                @let summaryColorsName =
                    "summaryColorsName" | t;
                <div class="left-area">
                    <ng-container
                        *ngComponentOutlet="
                            listManagerType;
                            inputs: { config: withSummaryListName(summaryColorsName) }
                        "
                    ></ng-container>
                </div>
            }

            <div class="right-area">
                <cerrix-riskmatrix-summary
                    [matrix]="value"
                    [cellSize]="cellSize"
                    [cellSpacing]="cellSpacing"
                    (cellClick)="matrixCellClick($event.Likelihood, $event.Impact)"
                ></cerrix-riskmatrix-summary>
            </div>
        </div>
    }
}
